<template>
  <v-app>
    <v-toolbar height="55" class="col-xs-12" fixed>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <img
        v-if="restLogo != ''"
        class="smallImgWidth"
        style="width: 50px;height: 50px; margin-left:0px;max-width:80px;"
        :src="restLogo"
      />
      <div v-if="errorState == ''" class="col-xs-8 col-md-8" style="padding:0px;margin-left:5px;">
        <h3 v-if="hdrTitleName == ''" class="hdrTtl" style="margin:0px;">{{hdrTitle}}</h3>
        <h3
          v-if="hdrTitleName != ''"
          class="hdrTtl"
          style="margin:0px;"
        >{{hdrTitle}} - {{$t(hdrTitleName)}}</h3>
      </div>
      <v-spacer></v-spacer>

      <v-switch
        v-if="globalVar.mode == 'normal' && (userPosition =='Staff' && errorState == '')"
        v-model="businessState"
        style="margin:0px;width：150px;"
        :label="businessState == true ? $t('Open') : $t('Close') "
        @change="checkBusinessStatus(businessState)"
      ></v-switch>

      <!-- change Lang -->
      <!-- <p style="font-size:12px;margin-left:15px;margin-bottom:10px;">{{$t('Language')}}</p> -->
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon style="font-size: 32px;">translate</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-tile v-for="l in langList" :key="l" @click="changeLocalLang(l)">
            <v-list-tile-title>{{ l }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <div v-if="errorState != ''" style="text-align: center;">
        <h3 style="font-size:14px;" class="txtClrRed">{{$t('ErrorState')}}: {{errorState}}</h3>
      </div>
      <!-- <v-toolbar-title style="min-width:40px;" @click="backToBackendLogin()">
        <button class="btn">Logout</button>
      </v-toolbar-title>-->
    </v-toolbar>

    <v-navigation-drawer id="drawer" v-model="drawer" temporary width="85" fixed>
      <v-icon style="font-size: 32px;float:right;" @click.stop="drawer = !drawer">cancel</v-icon>
      <div v-if="globalVar.mode == 'normal'">
        <v-btn
          color="primary"
          style="min-width: 0;padding: 7px;padding-top:8px;min-width:65px;"
          @click="btnClickTask('Order')"
        >{{$t('Order')}}</v-btn>
        
        <div v-if="userPosition=='Admin'">
          <v-btn
            color="primary"
            style="min-width: 0;padding: 12px;padding-top:10px;min-width:65px;"
            @click="btnClickTask('Stall')"
          >{{$t('Stall')}}</v-btn>
          <v-btn
            color="primary"
            style="min-width: 0;padding: 13.5px;padding-top:8px;min-width:65px;"
            @click="btnClickTask('User')"
          >{{$t('User')}}</v-btn>
          <!-- <v-btn
          color="primary"
          style="min-width: 0;padding: 3px;min-width:65px;height:45px;"
          @click="btnClickTask('OrderList')"
        >
          <span style="width: 60px;white-space: normal;">{{$t('OrderList')}}</span>
          </v-btn>-->
          <v-btn
            color="primary"
            style="min-width: 0;padding: 3px;min-width:65px;"
            @click="btnClickTask('MchtConfig')"
          >
            <span style="width: 60px;white-space: normal;">{{$t('Setting')}}</span>
          </v-btn>
        </div>
        <div v-if="userPosition=='Staff'">
          <!-- ///Temporary Close
          <v-btn
            color="warning"
            style="height:50px;min-width: 0px;padding: 5px 2px 5px 2px;"
            @click="btnClickTask('NewOrder')"
          >
            <span style="width: 60px;white-space: normal;">{{$t('NewOrder')}}</span>
          </v-btn>-->
          <v-btn
            color="primary"
            style="min-width: 0;padding: 12px;padding-top:10px;min-width:65px;"
            @click="btnClickTask('Menu')"
          >{{$t('Menu')}}</v-btn>
          <v-btn
            color="primary"
            style="min-width: 0;padding: 3px;min-width:65px;"
            @click="btnClickTask('KtnConfig')"
          >{{$t('Setting')}}</v-btn>
        </div>
      </div>
      <div v-if="globalVar.mode == 'lite'">
        <v-btn
          color="primary"
          style="min-width: 0;padding: 7px;padding-top:8px;min-width:65px;"
          @click="btnClickTask('Order')"
        >{{$t('Order')}}</v-btn>
        <v-btn
          color="primary"
          style="min-width: 0;padding: 12px;padding-top:10px;min-width:65px;"
          @click="btnClickTask('Menu')"
        >{{$t('Menu')}}</v-btn>
        <!-- <v-btn
          color="primary"
          style="min-width: 0;padding: 3px;min-width:65px;"
          @click="btnClickTask('OrderList')"
        >
          <span style="width: 60px;white-space: normal;">{{$t('History')}}</span>
        </v-btn>-->
        <v-btn
          color="primary"
          style="min-width: 0;padding: 3px;min-width:65px;"
          @click="btnClickTask('MchtConfig')"
        >
          <span style="width: 60px;white-space: normal;">{{$t('Setting')}}</span>
        </v-btn>
        <v-btn
          color="primary"
          style="padding: 1px;min-width:65px;font-size:12px;"
          @click="btnClickTask('Account')"
        >
          <span style="width: 60px;white-space: normal;">{{$t('Account')}}</span>
        </v-btn>
      </div>
      <v-btn
        color="primary"
        style="min-width: 0;padding: 4px;min-width:65px;"
        @click="btnClickTask('Report')"
      >{{$t('Report')}}</v-btn>
      <v-btn
        color="primary"
        style="min-width: 0;padding: 0px;min-width:65px;height:45px;"
        @click="btnClickTask('ChangePassword')"
      >
        <!-- <span style="width: 60px;white-space: normal;">{{$t('OrderList')}}</span> -->
        <span
          style="font-size:11px;width: 68px;white-space: normal;word-wrap: break-word;"
        >{{$t('ChangePassword')}}</span>
      </v-btn>
      <v-btn
        color="error"
        style="min-width: 0;padding: 3.5px;min-width:65px;"
        @click="backToBackendLogin()"
      >{{$t('Logout')}}</v-btn>
    </v-navigation-drawer>

    <v-layout xs12 style="margin-top:55px;">
      <v-flex xs12 sm12 md12 style="padding:5px;min-width:250px;">
        <ExpBanner v-if="globalVar.mode == 'lite' && expBnrTxt != ''"></ExpBanner>
        <div v-if="globalVar.mode == 'normal'">
          <div
            v-if="userPosition=='Admin' && (sltSlideTitle === '' || sltSlideTitle === 'Stall')"
            :key="componentKey"
          >
            <Stall></Stall>
          </div>
          <div v-if="userPosition=='Admin' && sltSlideTitle === 'User'" :key="componentKey">
            <User></User>
          </div>
          <div v-if="userPosition=='Admin' && sltSlideTitle === 'OrderList'" :key="componentKey">
            <OrderList></OrderList>
          </div>
          <div v-if="userPosition=='Admin' && sltSlideTitle === 'MchtConfig'" :key="componentKey">
            <MchtConfig></MchtConfig>
          </div>

          <div
            v-if="(userPosition=='Staff' && (sltSlideTitle === '' || sltSlideTitle === 'Order')) || (userPosition=='Admin' && sltSlideTitle === 'Order')"
            :key="componentKey"
          >
            <Order></Order>
          </div>
          <div v-if="userPosition=='Staff' && sltSlideTitle === 'Menu'" :key="componentKey">
            <Menu></Menu>
          </div>
          <div v-if="userPosition=='Staff' && sltSlideTitle === 'KtnConfig'" :key="componentKey">
            <KtnConfig></KtnConfig>
          </div>
        </div>

        <div v-if="globalVar.mode == 'lite'">
          <!-- <div v-if="sltSlideTitle === 'OrderList'" :key="componentKey">
            <OrderList></OrderList>
          </div>-->
          <div v-if="sltSlideTitle === 'MchtConfig'" :key="componentKey">
            <MchtConfig></MchtConfig>
          </div>

          <div v-if="(sltSlideTitle === '' || sltSlideTitle === 'Order')" :key="componentKey">
            <Order></Order>
          </div>
          <div v-if="sltSlideTitle === 'Menu'" :key="componentKey">
            <Menu></Menu>
          </div>
          <div v-if="sltSlideTitle === 'Account'" :key="componentKey">
            <Account></Account>
          </div>
        </div>

        <div v-if="sltSlideTitle === 'Report'" :key="componentKey">
          <Report></Report>
        </div>

        <div v-if="sltSlideTitle === 'ChangePassword'" :key="componentKey">
          <ChangePassword></ChangePassword>
        </div>
      </v-flex>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="ShopCloseDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline warning"
            primary-title
            style="color: white;"
          >{{$t('Warning')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('UnablePlaceOrderTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="ShopCloseDialog = false">{{$t('Ok')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
import Vue from 'vue'
import JS from './JsonService'
import Stall from '../src/Stall'
import User from '../src/User'
import OrderList from '../src/OrderList'
import MchtConfig from '../src/MchtConfig'
import Order from '../src/Order'
import Menu from '../src/Menu'
import Account from '../src/Account'
import ExpBanner from '../src/ExpBanner'
import KtnConfig from '../src/KtnConfig'
import Report from '../src/Report'
import ChangePassword from '../src/ChangePassword'
import i18n from './i18n'
import globalVar from './GlobalVar.js'
import VersionDialog from '../src/VersionNotMatchDialog'
import { translateErrorMsg } from './translateErrorMsg'
export default {
  components: {
    Stall,
    User,
    OrderList,
    MchtConfig,
    Order,
    Menu,
    Account,
    KtnConfig,
    Report,
    ChangePassword,
    VersionDialog,
    ExpBanner
  },
  mixins: [translateErrorMsg],
  data() {
    return {
      langList: ['English', '中文'],
      hdrTitle: 'eOrder',
      hdrTitleName: '',
      userPosition: '',
      businessState: true,
      sltSlideTitle: '',
      componentKey: 0,
      errorState: '',
      ShopCloseDialog: false,
      restLogo: '',
      drawer: false,
      versionError: false,
      expBnrTxt: '',
      globalVar: globalVar
    }
  },
  created: function() {
    history.pushState(null, null, location.href)
    // history.back()
    // history.forward()
    window.onpopstate = function() {
      // this.$router
      history.go(1)
    }
    sessionStorage.setItem('backEndAddOrdKtnId', 0)
    sessionStorage.setItem('backEndAddOrd', false)
    if (sessionStorage.getItem('restLogo')) {
      this.restLogo = sessionStorage.getItem('restLogo')
    } else {
      this.restLogo = ''
    }
    let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
    console.log(userInfo)

    //     Name: this.res.data.ez,
    //     Level: this.res.data.aq,
    //     KtnID: this.res.data.rd,
    //     KtnCode: this.res.data.qz,
    //     KtnName: this.res.data.ra,
    //     KtnOpen: this.res.data.rb,
    //     KtnActive: this.res.data.rc

    this.businessState = userInfo.KtnOpen
    this.expBnrTxt = userInfo.ExpireBanner

    if (globalVar.mode == 'normal') {
      if (userInfo.KtnID == 0) {
        this.userPosition = 'Admin'
      } else {
        this.userPosition = 'Staff'
      }
    }

    const title = sessionStorage.getItem('sltTaskTitle')
    // console.log(title)
    if (title == '' || title == null || title == undefined) {
      this.btnClickTask('')
    } else {
      this.btnClickTask(title)
    }
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    changeLocalLang(l) {
      var lTxt
      if (l == '中文') {
        lTxt = 'zh-chs'
      } else {
        lTxt = 'en-us'
      }

      //console.log(lTxt)
      //console.log($cookies.get('lang'))

      if (lTxt != Vue.$cookies.get('lang')) {
        console.log(lTxt)
        Vue.$cookies.set('lang', lTxt)
        i18n.locale = lTxt
        //this.getSideBarItem('notDefault')
        // var sltMenu = JSON.parse(sessionStorage.getItem('sltMenu'))
        // var sltMenuSub = JSON.parse(sessionStorage.getItem('sltMenuSub'))
        // console.log(sltMenu.SubMenu)
        // console.log(sltMenuSub)
        // if (sltMenu.SubMenu.length > 0) {
        //   this.withSubMenu(sltMenu, sltMenuSub)
        // } else {
        //   this.noSubMenu(sltMenu)
        // }
      }
    },
    checkBusinessStatus(bState) {
      this.versionError = false
      console.log('Business State: ', bState)
      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      console.log(userInfo)
      console.log(userInfo.KtnID)
      var version = sessionStorage.getItem('version')
      const url = 'Back/KtnOpen'
      const parameter = {
        av: version,
        kp: mchCode,
        rd: userInfo.KtnID,
        rb: bState
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false

            if (response.data.ht) {
              sessionStorage.setItem(
                'backendLoginInfo',
                JSON.stringify({
                  UserId: userInfo.m,
                  Name: userInfo.Name,
                  Level: userInfo.Level,
                  KtnID: userInfo.KtnID,
                  KtnCode: userInfo.KtnCode,
                  KtnName: userInfo.KtnName,
                  KtnOpen: bState,
                  KtnActive: userInfo.KtnActive,
                  ExpireBanner: userInfo.ExpireBanner
                })
              )
              this.errorState = ''
            } else {
              this.errorState = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.versionError = false
          this.errorState = error
        })
    },
    btnClickTask(title) {
      this.drawer = false
      if (title == '' || title == null || title == undefined) {
        var name = sessionStorage.getItem('backendLoginedUserName')

        if (globalVar.mode == 'normal') {
          if (this.userPosition == 'Admin') {
            this.hdrTitle = 'eOrder (' + name + ') '
            this.hdrTitleName = translateErrorMsg.titleName('Stall')
          } else if (this.userPosition == 'Staff') {
            this.hdrTitle = 'eOrder (' + name + ') '
            this.hdrTitleName = translateErrorMsg.titleName('Order')
          }
        } else if (globalVar.mode == 'lite') {
          this.hdrTitle = 'eOrder (' + name + ') '
          this.hdrTitleName = translateErrorMsg.titleName('Order')
        }
      } else {
        var name2 = sessionStorage.getItem('backendLoginedUserName')
        if (title == 'NewOrder') {
          this.hdrTitle = 'eOrder (' + name2 + ') '
          this.hdrTitleName = ''
        } else {
          this.hdrTitle = 'eOrder (' + name2 + ') '
          this.hdrTitleName = translateErrorMsg.titleName(title)
        }
        //console.log(title)
      }

      if (title == 'NewOrder') {
        if (this.businessState == true) {
          sessionStorage.setItem('backEndAddOrd', true)
          let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
          sessionStorage.setItem('backEndAddOrdKtnId', userInfo.KtnID)

          if (globalVar.mode == 'normal') {
            this.$router.replace('/')
          } else if (globalVar.mode == 'lite') {
            var mchCd = sessionStorage.getItem('paramMchdCode')
            this.$router.replace({
              name: 'Search',
              params: { mchdCode: mchCd }
            })
          }
        } else {
          this.ShopCloseDialog = true
        }
      } else {
        this.sltSlideTitle = title
        sessionStorage.setItem('sltTaskTitle', title)
        this.componentKey += 1
      }
      //console.log(this.sltSlideTitle)
      window.scrollTo(0, 0)
    },
    backToBackendLogin() {
      if (globalVar.mode == 'normal') {
        this.$router.replace('/Back')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'Back', params: { mchdCode: mchCd } })
      }
    }
  }
}
</script>

<style>
body {
  overflow-x: hidden;
  overflow-y: hidden;
}
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px !important;
}
label {
  margin-bottom: 0px !important;
}
.hdrTtl {
  font-size: 20px;
}
@media (max-width: 500px) {
  .hdrTtl {
    font-size: 16px;
  }
}
@media (max-width: 450px) {
  .hdrTtl {
    font-size: 14px;
  }
}
</style>
